<template>
  <v-menu
      ref="menu_model"
      v-model="menu_model"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          v-model="model"
          :label="label"
          readonly
          v-bind="attrs"
          v-on="on"
          style="width: 100%;"
      />
    </template>
    <v-date-picker
        v-model="model"
        :min="minDate||null"
        :max="maxDate||null"
        no-title
        scrollable
    >
      <v-btn
          flat
          color="primary"
          @click="menu_model=false"
      >
        Cancel
      </v-btn>
      <v-btn
          style="color:white; background-color: rgb(51,82,128);"
          @click="$refs.menu_model.save(model)"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "InlineDatePicker",
  props: {
    label: String,
    model: String,
    minDate: String,
    maxDate: String,
  },
  data() {
    return {
      menu_model: null
    }
  },
  methods: {
    async sync() {
      this.$emit('update:model', this.model);
    }
  },
  watch: {
    model: {
      handler () {
        this.sync()
      },
      immediate: true
    }
  }
}
</script>

<style scoped>

</style>